<template>
  <div id="app">
    <div class="jiaM" v-if="jiaFlag">
      <p>招商加盟——咨询人：刘经理 联系电话：17710505631</p>
      <img @click="closeJia" src="@/assets/close.png" alt="" />
    </div>
    <!-- <img src="./assets/logo.png"> -->
    <Header />
    <div id="max_box" :style="{margin:jiaFlag?'130px auto 0px auto':'40px auto 0px auto'}">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header";

import Footer from "@/components/footer";
// import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
  name: "App",
  data() {
    return {
      jiaFlag: false,
      jiaFlagShow:true,
    };
  },
  components: {
    Header,
    Footer,
  },
  created() {
    let arr = ['/Soluc','/Solua','/Solub']
    this.$router.beforeEach((to, from, next) => {
        this.jiaFlagShow = false
        this.jiaFlag =false
        // arr.map(item=>{
        //   if(to.path === item){
        //     this.jiaFlagShow = true;
        //   }
        // })
        let { jiaFlag } = this
        this.$bus.$emit("clickOut",{ show:jiaFlag })
        // if(to.path !== '/'){
          window.scrollTo(0,0)
        // }
        next();
    });
  },
  mounted: function () {
    this.$bus.$on("click", () => {
      this.jiaFlag = true;
    });
  },
  methods: {
    closeJia() {
      this.jiaFlag = false;
      this.$bus.$emit("clickOut",'')
    },
  },
};
</script>

<style>
/* @import "swiper/dist/css/swiper.css"; */
* {
  margin: 0;
  padding: 0;
}
ul {
  list-style: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  margin: 0;
  padding: 0;
  height: 100%;
  background-image: url("https://www.bjecpower.com/camera/company/ec.png");
  background-size: 100% 100%;
  position: relative;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  float: left;
}
#app > #max_box {
  /* margin: 40px auto 0px auto;
  margin: 0 auto; */
}
.jiaM {
  width:100%;
  height: 90px;
  background-image: url("https://www.bjecpower.com/img/gw/b02.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10;
}
.jiaM p {
  width:67%;
  text-align: center;
  font-size: 24px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #dfd3c7;
  line-height: 90px;
  
}
.jiaM img {
  width: 29px;
  height: 29px;
 
  /* margin-left: 169px; */
}
.home_con {
  width:1000px;
  max-width:1000px;
  /* width: 69%; */
  margin: 0 auto;
  box-sizing: border-box !important;
  display: "" !important;
}
.home_tit {
  /* width: 100%; */
  font-size: 32px;
  color: #191c27;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  text-align: center;
    line-height: 48px;
  padding: 64px 0px 56px 0px;
}

.mentIndex {
  background: #fff;
  box-sizing: border-box;
}
.mentCon {
  margin-left: 40px;
  margin-bottom: 46px;
}

.mentCon .ment_title {
  width: 586px;
  height: 100px;
  font-size: 26px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 100px;
  border-bottom: 1px solid #e5e5e5;
}
.mentCon p {
  margin: 23px 0px 12px 0px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 24px;
}
.mentCon small {
  font-size: 12px;
  margin-bottom: 12px;
  display: block;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 18px;
}
.mentCon span {
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 18px;
}
.mentCon img {
  margin: 24px 0px 12px 0px;
}
.soluction {
  width: 100%;
  background: #fff;
}
.solu_header {
  width: 100%;
  height: 418px;
  background: #f3f5fc;
}
.header_leftzong {
  display: flex;
  /* margin-bottom: 55px; */
}
.title_flex {
  display: flex;
  padding: 56px 0px 28px 0px;
}
.solu_title {
  font-size: 32px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #191c27;
  line-height: 48px;
}

.header_left {
  width: 48.8%;
  height: 226px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
}
.header_left img {
  width: 100%;
  height: 86px;
}
.header_left p {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 21px;
  text-align:left;
  padding: 32px 24px;
}
.header_left p span:nth-child(2) {
  display: block;
  padding-top: 16px;
}
.header_left .span_no {
  padding-top: 0px !important;
}
a{text-decoration:none}
.left_aa {
  margin-left: 24px;
}
.hh_title {
  text-align: left;
}
.hh_title img {
  width: 28px;
  height: 28px;
}
.hh_title p {
  font-size: 24px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #191c27;
  line-height: 36px;
  margin: 21px 0px 48px 0px;
}
.mentCon .mo_img {
  display: none;
}
@media screen and (max-width: 768px) {
  #app {
    background-image: url("");
    background-size: 0% 0%;
    background: #fff;
  }
  .home_pos {
    display: none;
  }
  
  .solu_header {
  width: 100%;
  height: 418px;
  background: #fff;
}



  .title_flex {
    display: block;
    padding: 50px 0px 9px 0px;
  }

  .header_left img {
    width: 35px;
    height: 35px;
  }

  .header_left p {
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
    padding: 17px 15px;
    text-align: left;
  }
  .header_left span:nth-child(2) {
    display: block;
    padding-top: 0px;
  }
  .left_aa,
  .left_bb {
    margin-left: 0px;
  }
  .left_bb {
    margin-top: -22px;
  }

  .hh_title {
    text-align: left;
    display: flex;
    align-items: center;
    margin-top: 40px;
  }
  .hh_title img {
    width: 16px;
    height: 17px;
    margin: 0px 12px 0px 15px;
  }
  .hh_title p {
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 18px;
    margin: 0px;
  }


  .solu_title {
    font-size: 22px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #191c27;
    line-height: 22px;
  }
  .solu_title_er {
    margin-top: 16px;
    font-size: 12px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #9ea5bb;
    line-height: 11px;
  }


  .moment {
    margin: 0px 15px 0px 15px;
    display: none;
  }
  .mentCon {
    width: 100%;
    margin: 0px 15px 32px 15px;
  }

  .mentCon .ment_title {
    width: 100%;
    height: 74px;
    font-size: 17px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #191c27;
    padding:0px 0px 8px 0px;
    border-bottom: 1px solid #e5e5e5;
  }
  .mentCon p {
    width: 92%;
    margin: 24px 0px 16px 0px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #191c27;
    line-height: 24px;
  }
  .mentCon small {
    margin-bottom: 12px;
    display: block;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #191c27;
    line-height: 21px;
  }
  .mentCon span {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #5a6073;
    line-height: 20px;
  }
  .mentCon .pc_img {
    display: none;
  }
  .mentCon .mo_img {
    display: block;
    width:100%;
  }
  .home_con {
    width: 100%;
    display: "" !important;
    overflow: hidden;
  }
  .home_tit {
    font-size: 22px;
    font-weight: bold;
    color: #191c27;
    line-height: 22px;
    padding: 50px 0px 24px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue